import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DFCalcMethodService,
  DFRatioObj,
  DFRatioService,
  DFSourcePriceService,
} from "../../model/backoffice/df-ratio";
import { FormObjectService } from "../../core/FieldObject";
import FormAutoObject from "../../core/FormAutoObject";
import { AlertOK } from "../../core/Helper";
import { GetEditorForm } from "../../core/Helper2";

export default function DFRatioEditor(props) {
  const userInfo = useSelector((state) => state.user.detail);
  const [objField, setObjField] = useState([]);
  const [data, setData] = useState([]);
  const [form, setForm] = useState(null);
  const [srcPriceList, setSrcPriceList] = useState([]);
  const [calcMethodList, setCalcMethodList] = useState([]);
  const [editor, setEditor] = props.editor;
  const refForm1 = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (editor?.show) {
      loadSourcePrice();
      if (editor?.idValue > 0) {
        getOldData();
      }

      return () => {
        clearObject();
      };
    }
  }, [editor?.show]);

  /**ล้างข้อมูล */
  const clearObject = () => {
    setData([]);
    setSrcPriceList([]);
    setCalcMethodList([]);
    setForm(null);
    setObjField(null);
  };

  useEffect(() => {
    if (editor?.show && srcPriceList) {
      buildForm();
    }
  }, [srcPriceList, calcMethodList]);

  // โหลดที่มาของราคาคิด DF
  const loadSourcePrice = async (text) => {
    setSrcPriceList(
      await DFSourcePriceService.GetList({ text: text }, userInfo)
    );
    setCalcMethodList(
      await DFCalcMethodService.GetList({ text: null }, userInfo)
    );
  };

  /** Build Form objects */
  const buildForm = async () => {
    setObjField(
      await FormObjectService.BuildsFormOBJs(
        DFRatioObj({
          sourcePriceList: srcPriceList,
          calcMethodList: calcMethodList,
        })
      )
    );
  };

  /** ดึงข้อมูลเก่า */
  const getOldData = async () => {
    let ret = await DFRatioService.GetItem(
      { [editor.idFieldName]: editor.idValue },
      userInfo
    );
    if (ret) {
      setData(ret);
    }
  };

  /** แสดงฟอร์ม */
  useEffect(() => {
    if (objField != null) {
      renderForm();
    }
  }, [objField, data]);

  /** Render form */
  const renderForm = async () => {
    setForm(
      <FormAutoObject
        {...{
          items: objField,
          dataValue: [data, setData],
          refTo: refForm1,
          style: { ...{ padingInline: "10px" } },
        }}
      />
    );
  };

  const actionSave = async () => {
    let fData1 = {
      ...Object.fromEntries(new FormData(refForm1.current)),
      [editor.idFieldName]: editor.idValue,
    };
    //include selector options
    fData1 = FormObjectService.IncludeSelectorKeyField(fData1, objField);
    //change "on" to true
    FormObjectService.ConvertSwitchON2Boolean(fData1);
    let ret = await DFRatioService.SaveItem(fData1, userInfo);
    if (ret != null) {
      AlertOK("บันทึกเรียบร้อย", dispatch);
      editor.action();
    }
  };

  return (
    <>
      <GetEditorForm
        {...{
          title: "สร้าง/แก้ไข อัตราค่าตอบแทน",
          form: [form, setForm],
          editor: [editor, setEditor],
          saveData: actionSave,
        }}
      />
    </>
  );
}
